<template>
	<div class="course_bottomRight">
		<div class="course_title">课堂笔记
			<div class="r">
				<el-button type='warning' @click='opennote'>记笔记</el-button>
			</div>
		</div>
		<div class="course_tabNormal">
			<div class="course_noteChapter text-ellipsis">
				{{chapterName}}-{{sectionName}}<span class="warningColor">（总计{{noteTotal}}个笔记）</span>
			</div>
		</div>
		<div class="course_noteList clearfix">
			<emptymain :emptytext="'暂无笔记'" :emptylist='noteList'></emptymain>
			<div class="course_noteItem" v-for="item in noteList">
				<img src="@/images/course_noteBack.png" class="course_noteBack" />
				<div class="course_noteItemCont">
					<div class="course_noteItemType">
						<img src="@/images/note_left.png" />
						<span>课堂笔记</span>
					</div>
					<div class="course_noteItemEdit">
						<i class="el-icon-edit" @click="openEdit(item)"></i>
						<i class="el-icon-delete" @click="deleteNote(item)"></i>
					</div>
					<div class="course_noteItemTitle text-ellipsis">{{item.title}}</div>
					<div class="course_noteItemText">{{item.description}}</div>
					<div class="course_noteItemTime">{{item.updateTime |formatTime}}</div>
				</div>
			</div>
		</div>
		<el-dialog title="我的笔记" class="open_dialogInfo" :visible.sync="note" :append-to-body='true' width="1000px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<div class="clearfix">
				<div class="normal_input ">
					<div class="note_noteTop">
						<div id="noteToolbar">
							<button class="ql-bold"></button>
							<button class="ql-italic"></button>
							<button class="ql-image"></button>
							<select class="ql-align">
								<option value="justify" selected></option>
								<option value="center"></option>
								<option value="right"></option>
							</select>
						</div>
					</div>
					<div class="note_noteTite">
						<input v-model="title" type="text" placeholder="请输入标题" />
					</div>
					<div class="not_noteCont ">
						<quill-editor class="editor beautifulScroll" ref="noteQuillEditor" :content="content" @change="onEditorChange($event)" :options="editorOption"></quill-editor>
					</div>
					<div class="uploadBox" v-show="false">
						<div class="uploadList">
							<el-upload action="" :with-credentials='true' :on-success='uploadNotesuccess' :multiple='false' name='file' accept='image/*' :show-file-list='false' :http-request="formRequest">
								<div class="uploadBotebtninner">
									<i class="el-icon-plus"></i>
								</div>
							</el-upload>
							<div style="clear: both;"></div>
						</div>
					</div>
				</div>
				<div class="all_current">
					<el-button type="info" @click="cancelAdd">取 消</el-button>
					<el-button type="primary" @click="noteChapters" :disabled='dataloading' v-if="!isEdit">确 定</el-button>
					<el-button type="primary" @click="noteChaptersEdit" :disabled='dataloading' v-if="isEdit">确 定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { putProgress } from "@/utils/oss.js";
	import { mynoteList, notePublish, noteRemove, noteUpdate } from '@/api/note.js'
	export default {
		props: {
			courseId: String,
			chapterId: String,
			sectionId: String,
			chapterName: String,
			sectionName: String,
		},
		data() {
			return {
				limit: 1000,
				dataloading: false,
				isEdit: false,
				note: false,
				firstnote: true,
				content: '',
				description: '',
				title: '',
				id: '',
				notePage: 1,
				noteTotal: 0,
				noteList: [],
				editorOption: {
					modules: {
						toolbar: '#noteToolbar',
					},
					placeholder: '请输入内容',
				},
			}
		},
		created() {
			this.getNoteList();
		},
		watch: {
			sectionId() {
				this.getNoteList();
			},
		},
		methods: {
			onEditorChange(res) {
				this.description = res.text;
				this.content = res.html;
			},
			opennote() {
				this.note = true;
				this.isEdit = false;
				if(this.firstnote) {
					this.firstnote = false
					this.editorUpload();
				}
			},
			editorUpload() {
				var that = this;
				this.$nextTick(() => {
					var noteQuillEditor = that.$refs.noteQuillEditor;
					var imgHandler = async function(image) {
						that.addNoteImgRange = that.$refs.noteQuillEditor.quill.getSelection();
						if(image) {
							document.getElementsByClassName('uploadBotebtninner')[0].click()
						}
					}
					that.$refs.noteQuillEditor.quill.getModule("toolbar").addHandler("image", imgHandler);
				})
			},
			getNoteList() {
				var data = {
					limit: this.limit,
					current: this.notePage,
					courseId: this.courseId,
					chapterId: this.chapterId,
					sectionId: this.sectionId,
				}
				mynoteList(data).then(res => {
					if(res.code == "OK") {
						this.noteList = res.data.records;
						this.noteTotal = res.data.total;
					}
				})
			},
			noteChapters() {
				this.dataloading = true;
				setTimeout(_ => {
					this.dataloading = false;
				}, 1000)
				if(!this.title) {
					this.$message.error('请输入标题！')
					return
				}
				if(!this.content) {
					this.$message.error('请输入内容！')
					return
				}
				var data = {
					title: this.title,
					content: this.content,
					description: this.description,
					courseId: this.courseId,
					chapterId: this.chapterId,
					sectionId: this.sectionId,
				}
				notePublish(data).then(res => {
					if(res.code == "OK") {
						this.cancelAdd()
						this.$message.success('发布成功')
						this.getNoteList();
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			cancelAdd() {
				this.isEdit = false;
				this.note = false;
				this.content = '';
				this.description = '';
				this.title = '';
				this.id = '';
			},
			openEdit(item) {
				this.note = true;
				if(this.firstnote) {
					this.firstnote = false
					this.editorUpload();
				}
				this.isEdit = true;
				this.content = item.content;
				this.description = item.description;
				this.title = item.title;
				this.id = item.id;
			},
			noteChaptersEdit() {
				this.dataloading = true;
				setTimeout(_ => {
					this.dataloading = false;
				}, 1000)
				if(!this.title) {
					this.$message.error('请输入标题！')
					return
				}
				if(!this.content) {
					this.$message.error('请输入内容！')
					return
				}
				var data = {
					id: this.id,
					title: this.title,
					content: this.content,
					description: this.description,
				}
				noteUpdate(data).then(res => {
					if(res.code == "OK") {
						this.cancelAdd()
						this.$message.success('修改成功')
						this.getNoteList();
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			deleteNote(item, index) {
				this.$confirm('确定删除笔记吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var data = {
						noteId: item.id
					}
					noteRemove(data).then(res => {
						if(res.code == "OK") {
							this.getNoteList()
						} else {
							this.$message.error('删除失败')
						}
					})
				}).catch(() => {
					this.$message.info('已取消删除')
				});
			},
			get_suffix(filename) {
				let pos = filename.lastIndexOf('.')
				let suffix = ''
				if(pos != -1) {
					suffix = filename.substring(pos)
				}
				return suffix
			},
			formRequest(file) {
				let that = this;
				var dir = 'vr/stuNote/';
				var noeDate = new Date();
				var year = noeDate.getFullYear();
				var month = noeDate.getMonth() + 1;
				month = month < 10 ? '0' + month : month;
				var day = noeDate.getDate();
				day = day < 10 ? '0' + day : day;
				dir = dir + year + "/" + month + "/" + day + '/';
				const uploadfile = file.file;
				const key = dir + noeDate.getTime() + this.get_suffix(file.file.name);
				putProgress(key, uploadfile, function(progressEvent) {
					let e = {}
					e.percent = progressEvent * 100 || 0;
					file.onProgress(e)
				}).then(res => {
					let e = {
						code: "OK",
						success: true,
						message: '',
						data: key
					}
					file.onSuccess(e)
				});
			},
			uploadNotesuccess(res, file, fileList) {
				var _this = this;
				var baseurl = this.baseurl;
				if(res) {
					var value = baseurl + res.data;
					_this.addNoteImgRange = _this.$refs.noteQuillEditor.quill.getSelection()
					_this.$refs.noteQuillEditor.quill.insertEmbed(_this.addNoteImgRange != null ? _this.addNoteImgRange.index : 0, 'image', value, null)
				}
			},
		},
	}
</script>